<article class="mg-acclaim-main">
<app-navbar *ngIf="globals.User.Token"></app-navbar>
<app-solmenu *ngIf="globals.User.Token"></app-solmenu>
<router-outlet></router-outlet>
<app-sagmenu *ngIf="globals.User.Token"></app-sagmenu>
<app-footer></app-footer>
</article>